import { useTranslations } from "next-intl";

/** Screen-reader-only keyboard hint for a sidebar nav, referenced by its `aria-describedby` */
export function NavInstructions({ id }: { id: string }) {
  const t = useTranslations("documentsSidebar");

  return (
    <p id={id} className="sr-only">
      {t("navigationInstructions")}
    </p>
  );
}
